/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Account Manager API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../runtime';
/**
 *
 * @export
 * @interface UpdateAdClientRequestDto
 */
export interface UpdateAdClientRequestDto {
    /**
     *
     * @type {string}
     * @memberof UpdateAdClientRequestDto
     */
    adClientId?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateAdClientRequestDto
     */
    adClientName?: string | null;
    /**
     *
     * @type {string}
     * @memberof UpdateAdClientRequestDto
     */
    primaryContactName?: string | null;
    /**
     *
     * @type {string}
     * @memberof UpdateAdClientRequestDto
     */
    phone?: string | null;
    /**
     *
     * @type {string}
     * @memberof UpdateAdClientRequestDto
     */
    email?: string | null;
}

/**
 * Check if a given object implements the UpdateAdClientRequestDto interface.
 */
export function instanceOfUpdateAdClientRequestDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateAdClientRequestDtoFromJSON(json: any): UpdateAdClientRequestDto {
    return UpdateAdClientRequestDtoFromJSONTyped(json, false);
}

export function UpdateAdClientRequestDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UpdateAdClientRequestDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        adClientId: !exists(json, 'ad_client_id') ? undefined : json['ad_client_id'],
        adClientName: !exists(json, 'ad_client_name') ? undefined : json['ad_client_name'],
        primaryContactName: !exists(json, 'primary_contact_name')
            ? undefined
            : json['primary_contact_name'],
        phone: !exists(json, 'phone') ? undefined : json['phone'],
        email: !exists(json, 'email') ? undefined : json['email'],
    };
}

export function UpdateAdClientRequestDtoToJSON(value?: UpdateAdClientRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ad_client_id: value.adClientId,
        ad_client_name: value.adClientName,
        primary_contact_name: value.primaryContactName,
        phone: value.phone,
        email: value.email,
    };
}
